import React from "react";
import moment from "moment";
import { CheckSquare, Square } from "react-feather";
import modulosId from "../mocks/modulos";

export const taskUtil = (task) => ({
  ...task,

  toCalendar: () => {
    const tarea = {
      start: new Date(),
      end: new Date(),
      title: task.title,
    };
    return tarea;
  },

  dueDate: () => {
    return new Date(moment(task.dueDate).add(1, "hour"));
  },

  completeDate: () => {
    return task.completeDate ? new Date(moment(task.completeDate).add(1, "hour")) : null;
  },

  statusHtml: () => {
    if (task.status === "resuelto") {
      return <span className="text-success">Resuelto</span>;
    }
    if (task.status === "vencido") {
      return <span className="text-danger">Vencido</span>;
    }
    return <span className="text-warning">Pendiente</span>;
  },

  canSetCompleted(currentUser, currentIndex, nextToCompleteIndex, centralizer) {
    if (!task.completeDate) {
      if (currentUser.haveAuditAccess(modulosId.CALENDAR)) {
        // el auditor del modulo no puede completar
        return false;
      }
      if (currentUser.haveAdminAccess(modulosId.CALENDAR)) {
        // el admin del modulo puede completar
        return true;
      }
      if (centralizer && this.liderOrResponsable(currentUser)) {
        // para modo centralizador, habilita completar solo para el responsable y/o lider
        return true;
      }
      if (this.liderOrResponsable(currentUser) && currentIndex === nextToCompleteIndex) {
        // es el responsable y/o lider de esta tarea
        return true;
      }
    }
    return false;
  },

  canSetRejected(currentUser, tasks, currentIndex, nextToCompleteIndex, centralizer) {
    if (task.completeDate) {
      if (currentUser.haveAuditAccess(modulosId.CALENDAR)) {
        // el auditor del modulo no puede rechazar
        return false;
      }
      if (currentUser.haveAdminAccess(modulosId.CALENDAR)) {
        // el admin del modulo puede rechazar
        return true;
      }
      if (centralizer && this.liderOrResponsable(currentUser)) {
        // para modo centralizador, habilita rechazo solo para el responsable y/o lider
        return true;
      }
      if (this.liderOrResponsable(currentUser) && (currentIndex === tasks.length - 1 || (nextToCompleteIndex && currentIndex === nextToCompleteIndex - 1))) {
        // el responsable y/o lider puede rechazarse su tarea
        return true;
      }
      if (nextToCompleteIndex && currentIndex === nextToCompleteIndex - 1 && taskUtil(tasks[nextToCompleteIndex]).liderOrResponsable(currentUser)) {
        // lider Y/o responsable de la proxima tarea
        return true;
      }
    }
    return false;
  },

  liderOrResponsable(currentUser) {
    return currentUser.user.Pi.itemId === task.responsableId || currentUser.user.Pi.itemId === task.liderId;
  },

  statusCheck(handleTogleCheck, currentUser, tasks, currentIndex, nextToCompleteIndex, centralizer) {
    if (this.canSetRejected(currentUser, tasks, currentIndex, nextToCompleteIndex, centralizer)) {
      return (
        <span className="action-box complete-btn" title="Completado">
          <CheckSquare color="red" onClick={() => handleTogleCheck(task.id)} />
        </span>
      );
    }
    if (this.canSetCompleted(currentUser, currentIndex, nextToCompleteIndex, centralizer)) {
      return (
        <span className="action-box complete-btn" title="Incompleto">
          <Square onClick={() => handleTogleCheck(task.id)} />
        </span>
      );
    }
    return <>&nbsp;</>;
  },

  statusStr: () => {
    if (task.status === "resuelto") {
      return "Resuelto";
    }
    if (task.status === "vencido") {
      return "Vencido";
    }
    return "Pendiente";
  },
});
